<template>
  <div class="info_box">
    <div class="owner_title">录入写手信息</div>
    <div class="owner_box">
      <el-form
        ref="writerInfoForm"
        :rules="rules"
        :model="writerInfoForm"
        label-width="120px"
      >
        <el-form-item label="写手昵称" prop="nickname">
          <el-input
            class="inpt_size"
            v-model="writerInfoForm.nickname"
          ></el-input>
        </el-form-item>
        <el-form-item label="写手姓名" prop="name">
          <el-input class="inpt_size" v-model="writerInfoForm.name"></el-input>
        </el-form-item>
        <el-form-item label="写手QQ" prop="qq_account">
          <el-input
            class="inpt_size"
            v-model="writerInfoForm.qq_account"
          ></el-input>
        </el-form-item>
        <el-form-item label="写手支付宝" prop="qq_account">
          <el-input
            class="inpt_size"
            v-model="writerInfoForm.alipay_account"
          ></el-input>
        </el-form-item>
        <el-form-item label="写手电话号码" prop="mobile">
          <el-input
            class="inpt_size"
            v-model="writerInfoForm.mobile"
          ></el-input>
        </el-form-item>
        <el-form-item label="初始压稿金额" prop="initial_press_release">
          <el-input
            class="inpt_size"
            v-model="writerInfoForm.initial_press_release"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="日周结" prop="settlement_type">
          <el-radio-group
            v-model="writerInfoForm.settlement_type"
            @change="changeLabel"
          >
            <el-radio :label="1">日结</el-radio>
            <el-radio :label="2">周结</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="添加标签" prop="connectionlabel_ids">
          <el-checkbox
            v-for="(item, index) in writerInfoForm.connectionlabel_ids"
            :key="index"
            :label="item.name"
            @change="checkedLabel(item)"
            >{{ item.name }}</el-checkbox
          >
        </el-form-item>
        <el-form-item label="添加批注" prop="connectionremark">
          <el-input
            class="add_ramark"
            v-model="writerInfoForm.connectionremark"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            class="info_btn"
            type="primary"
            round
            @click="onSubmitWriterInfo"
            >确认录入</el-button
          >
          <el-button class="info_btn" type="info" plain @click="goBack" round
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { add_writer, label_tabulation } from "@/utils/writer";
export default {
  data() {
    return {
      writerId: "", //所属写手部id
      writerLabelChecked: [], //选中标签
      writerInfoForm: {
        departmentuser_id: "", //所属写手部id
        nickname: "", //写手昵称
        name: "", //写手姓名
        qq_account: "", //写手qq
        alipay_account: "", //写手支付宝
        mobile: "", //写手电话号码
        initial_press_release: "0", //初始压稿金额
        settlement_type: "1", //日周结 1=日结,2=周结
        connectionlabel_ids: "", //标签
        connectionremark: "" //批注
      },
      rules: {
        nickname: {
          required: true,
          trigger: "blur",
          message: "写手昵称不能为空"
        },
        name: { required: true, trigger: "blur", message: "写手姓名不能为空" },
        qq_account: [
          {
            required: true,
            trigger: "blur",
            message: "写手QQ不能为空"
          },
          { pattern: /^[0-9]*$/, trigger: "blur", message: "QQ格式不正确" }
        ],
        alipay_account: {
          required: true,
          trigger: "blur",
          message: "写手支付宝不能为空"
        },
        initial_press_release: {
          required: true,
          trigger: "blur",
          message: "初始压稿金额不能为空"
        },
        mobile: [
          { required: true, trigger: "blur", message: "写手电话号码不能为空" },
          { max: 11, trigger: "blur", message: "手机格式不正确" }
          // {
          //   trigger: "blur",
          //   validator: (rule, value, callback) => {
          //     var passwordreg = /^(((13[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[3-8]{1})|(18[0-9]{1})|(19[0-9]{1})|(14[5-7]{1}))+\d{8})$/;
          //     console.log(passwordreg.test(value));
          //     if (!passwordreg.test(value)) {
          //       callback(new Error("手机格式不正确!"));
          //     } else {
          //       callback();
          //     }
          //   }
          // }
        ],
        settlement_type: {
          required: true,
          trigger: "blur",
          message: "请选择日周结"
        }
      }
    };
  },
  created() {
    this.writerId = JSON.parse(localStorage.getItem("userInfo")).id;
    this.getWriterLabel();
  },
  methods: {
    onSubmitWriterInfo() {
      var that = this;
      that.$refs["writerInfoForm"].validate(valid => {
        if (valid) {
          var str = "";
          var len = that.writerLabelChecked.length;
          that.writerLabelChecked.forEach(function(item, index) {
            if (index < len - 1) {
              str += item + ",";
            } else {
              str += item;
            }
          });
          that.writerInfoForm.connectionlabel_ids = str;
          that.writerInfoForm.departmentuser_id = that.writerId;
          let obj = {
            ...that.writerInfoForm
          };

          add_writer(obj).then(res => {
            if (res.data.code == 1) {
              that.$message.success(res.data.msg);
              that.$router.push("/myWriter");
            } else {
              that.$message.error(res.data.msg);
            }
          });
        }
      });
    },
    // 获取标签列表
    getWriterLabel() {
      var that = this;
      label_tabulation().then(res => {
        if (res.data.code == 1) {
          that.writerInfoForm.connectionlabel_ids = res.data.data;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 选择标签
    checkedLabel(val) {
      var that = this;
      if (that.writerLabelChecked.includes(val.id)) {
        that.writerLabelChecked = that.writerLabelChecked.filter(
          item => item != val.id
        );
      } else {
        that.writerLabelChecked.push(val.id);
      }
    },
    // // 选择日周结
    // changeLabel(val) {
    //   this.writerInfoForm.settlement_type = val;
    // },
    //   取消返回首页
    goBack() {
      var that = this;
      that.$router.push("/myWriter");
    }
  }
};
</script>
<style scoped>
.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}
.info_box {
  background-color: #ffffff;
  height: 100%;
}
.owner_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  background: #ffffff;
  padding: 15px;
  border: 1px solid #e4e9f1;
}
.owner_box {
  padding: 45px 30px;
}
.el-main {
  padding: 0;
}
.inpt_size {
  width: 200px;
}
.add_ramark {
  width: 475px;
}
.upload_size {
  width: 230px;
}
.upload_icon {
  font-size: 15px;
  margin-right: 5px;
}
.info_btn {
  width: 200px;
  height: 35px;
}
.info_box .el-input__inner {
  border: 1px solid #dcdfe6 !important;
  background-color: RGB(250, 250, 250) !important;
}
</style>



// WEBPACK FOOTER //
// src/view/writer/WriterInfo.vue